import { IsNumber } from 'class-validator';

export class FireBalanceDto {
  id: number;

  @IsNumber()
  ican?: number;

  @IsNumber()
  balance?: number;
}
